/**
 * Minimal client-side CSV export (RFC-4180 quoting). Serializes the rows a list
 * is already showing and triggers a browser download — no server round-trip, no
 * change to any data. Used by operational list screens that want a quick
 * "export what I see" without a dedicated reporting endpoint.
 */
// UTF-8 byte-order mark, prepended so Excel opens non-ASCII (rupee, accents)
// correctly. Built from the char code to keep the source file pure-ASCII.
const BOM = String.fromCharCode(0xfeff);
/**
 * Quote one CSV field per RFC 4180: wrap in double-quotes if it contains a
 * comma, quote, CR or LF, doubling any embedded quotes. `null`/`undefined` is "".
 */
export function csvField(value) {
    const s = value == null ? '' : String(value);
    return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
/** Build a CSV string from a header row plus data rows (CRLF line endings). */
export function toCsv(headers, rows) {
    const lines = [headers.map(csvField).join(',')];
    for (const r of rows)
        lines.push(r.map(csvField).join(','));
    return lines.join('\r\n');
}
/** Trigger a browser download of `headers`+`rows` as a `.csv` file. */
export function downloadCsv(filename, headers, rows) {
    const blob = new Blob([BOM + toCsv(headers, rows)], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
